import { Chart } from '@frontend/chart/types';

export const PUDO_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: 'transaction_completed',
            data: [{ label: 'full_period', value: 603 }]
        },
        {
            name: 'transaction_created',
            data: [{ label: 'full_period', value: 17 }]
        },
        {
            name: 'transaction_pick_up_pending',
            data: [{ label: 'full_period', value: 43 }]
        },
        {
            name: 'transaction_draft',
            data: [{ label: 'full_period', value: 48 }]
        },
        {
            name: 'transaction_cancelled',
            data: [{ label: 'full_period', value: 12 }]
        },
        {
            name: 'transaction_drop_off_pending',
            data: [{ label: 'full_period', value: 6 }]
        }
    ]
};
